module.exports = "<mat-card-title>\n<a class=\"content-back-btn\" (click)=\"onBackButtonclick()\">Back</a>\n<h2>{{headertxt}}</h2>\n</mat-card-title>"